import { combineReducers } from "redux";
import auth from "./auth";
import context from "./context";
import { connectRouter } from "connected-react-router";
import toasts from "./toasts";
import popups from "./popups";
import register from "./register";
import registrations from "./registrations";
import volunteerRegistrations from "./volunteerRegistrations";

export default function createRootReducer(history) {
	return combineReducers({
		auth,
		context,
		popups: popups,
		router: connectRouter(history),
		toasts,
		register,
		registrations,
		volunteerRegistrations,
	});
}
